import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { getProductPrice } from '~/utils/ProductPrice';
import AzImg from '~/components/Atoms/AzImg.vue';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { useCart } from '@/composables/useCart';
import { useUser } from '~/composables/_next/useUser';
import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AddToCart from '~/components/Layout/Cart/AddToCart/AddToCart.vue';
import ProductPagePrice from '~/components/Product/ProductPrice/ProductPagePrice.vue';
import { useWait } from '~/composables/_next/useWait';
import { yieldToMain } from '~/utils/yieldToMain';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import useAddToCart from '~/composables/useAddToCart';
import useIsMobile from '~/composables/useIsMobile';
import { getIsNewProduct, getMainImage } from '~/helpers/productCardMethods';
import { gtmValue } from '~/helpers/gtm';
import { ProductAttributes as ProductEnumsAttributes } from '~/types/ProductEnums';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
import { getProductAttributes } from '~/utils/commercetools/attributes';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCartProductPage',
  props: {
    qty: {
      type: Number,
      default: 0
    },
    isSticky: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: function _default() {}
    },
    isInStock: {
      type: Boolean,
      default: false
    },
    isPortionLabelVisible: {
      type: Boolean,
      default: false
    },
    pricePerUnit: {
      type: Object,
      required: false
    },
    isBundle: {
      type: Boolean,
      default: false
    },
    bundleData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDiscontinued: {
      type: Boolean,
      default: false
    },
    isAvailableInCountry: {
      type: Boolean,
      default: true
    },
    isProductDiscontinued: {
      type: Boolean,
      default: false
    },
    isMobileView: {
      type: Boolean,
      default: false
    },
    isCustomizable: {
      type: Boolean,
      default: false
    },
    customizerNeutralBase: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    variants: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    variant: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isStickyDesktop: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addToCart'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useCustomizer = useCustomizer(),
      openModal = _useCustomizer.openModal,
      openCustomizer = _useCustomizer.openCustomizer;
    var _useAddToCart = useAddToCart(),
      normalizeVariants = _useAddToCart.normalizeVariants;
    var _useCart = useCart(),
      addItemById = _useCart.addItemById,
      cartLoading = _useCart.loading,
      cart = _useCart.cart;
    var _useUiState = useUiState(),
      openBackInStockModal = _useUiState.openBackInStockModal;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency,
      locale = _useLocalization.locale;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $sentry = _useNuxt2App.$sentry,
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      user = _useUser.user;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var route = useRoute();
    var isBookShop = computed(function () {
      var _props$variant;
      return ((_props$variant = props.variant) === null || _props$variant === void 0 ? void 0 : _props$variant._ProductType) === ProductEnumsAttributes.workshop;
    });
    var isButtonDisabled = computed(function () {
      return !(props !== null && props !== void 0 && props.isInStock) || (props === null || props === void 0 ? void 0 : props.isDiscontinued) || (props === null || props === void 0 ? void 0 : props.isProductDiscontinued) || !(props !== null && props !== void 0 && props.isAvailableInCountry);
    });
    var addToCartButtonText = computed(function () {
      if (!(props !== null && props !== void 0 && props.isAvailableInCountry)) {
        return i18n.t('addToCart.not-available-in-country');
      }
      if (props.isBundle) {
        return i18n.t('addToCart.addToCartBundle');
      }
      return i18n.t('addToCart.addToCart');
    });
    var product = computed(function () {
      return props.variant;
    });
    var products = computed(function () {
      return props.variants;
    });
    var options = computed(function () {
      return getProductAttributes(products.value, ['color', 'capacity', 'capacity-unit', 'capacity-type']);
    });
    var configuration = computed(function () {
      return Object.keys(product.value).length !== 0 ? getProductAttributes(product.value, ['color', 'capacity', 'capacity-unit', 'capacity-type']) : {};
    });
    var defaultProductImage = computed(function () {
      var _products$value, _products$value$, _products$value$$imag, _products$value$$imag2;
      return (_products$value = products.value) === null || _products$value === void 0 ? void 0 : (_products$value$ = _products$value[0]) === null || _products$value$ === void 0 ? void 0 : (_products$value$$imag = _products$value$.images) === null || _products$value$$imag === void 0 ? void 0 : (_products$value$$imag2 = _products$value$$imag[0]) === null || _products$value$$imag2 === void 0 ? void 0 : _products$value$$imag2.url;
    });
    var portionLabel = computed(function () {
      var capacity = getLabel(options, configuration, 'capacity');
      var unit = getLabel(options, configuration, 'capacity-unit');
      return i18n.tc('addToCart.articleToPortion', capacity === null || capacity === void 0 ? void 0 : capacity.length, {
        capacity: capacity,
        unit: unit
      });
    });
    var portionLabelSticky = computed(function () {
      var capacity = getLabel(options, configuration, 'capacity');
      var unit = getLabel(options, configuration, 'capacity-unit');
      return capacity ? "".concat(capacity).concat(unit) : undefined;
    });
    var capacityLabel = computed(function () {
      return props.isBundle ? "".concat(props.bundleData.count, " ").concat(translate('addToCart.pluralArticles')) : portionLabelSticky.value;
    });
    var productName = computed(function () {
      var _product$value;
      return ((_product$value = product.value) === null || _product$value === void 0 ? void 0 : _product$value._name) || '';
    });
    var priceRegular = computed(function () {
      return getProductPrice(product.value).regular;
    });
    var priceSpecial = computed(function () {
      return getProductPrice(product.value).special;
    });
    var customerEmail = computed(function () {
      var _user$value;
      return isAuthenticated.value ? user === null || user === void 0 ? void 0 : (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    });
    var getProductMainImage = computed(function () {
      var _products$value2;
      return getMainImage((_products$value2 = products.value) === null || _products$value2 === void 0 ? void 0 : _products$value2[0]);
    });
    var productLink = computed(function () {
      return route.fullPath;
    });
    var numberItems = ref(props.qty);
    var items = ref('');
    var isAddToCartModalOpen = ref(false);
    function addToCartWorkshops() {
      return _addToCartWorkshops.apply(this, arguments);
    }
    function _addToCartWorkshops() {
      _addToCartWorkshops = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _props$variants, _props$variants$;
        var serviceTags;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              serviceTags = (_props$variants = props.variants) === null || _props$variants === void 0 ? void 0 : (_props$variants$ = _props$variants[0]) === null || _props$variants$ === void 0 ? void 0 : _props$variants$.sku;
              _context2.next = 3;
              return loadBooxi();
            case 3:
              openBooxi({
                serviceTags: serviceTags,
                bookingFlow: 'locations',
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      previousRoutePath: route.path,
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _addToCartWorkshops.apply(this, arguments);
    }
    function toggleAddToCartModal() {
      var _items$value$;
      emit('addToCart', {
        dataWorkshop: items.value,
        ProductQty: (items === null || items === void 0 ? void 0 : (_items$value$ = items.value[0]) === null || _items$value$ === void 0 ? void 0 : _items$value$.quantity) || numberItems.value
      });
      if (useIsMobile()) {
        isAddToCartModalOpen.value = !isAddToCartModalOpen.value;
      }
    }
    function pushAddToCartAnalytics() {
      return _pushAddToCartAnalytics.apply(this, arguments);
    }
    function _pushAddToCartAnalytics() {
      _pushAddToCartAnalytics = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _product$value2, _product$value3, _product$value4, _product$value5, _product$value6, _product$value6$price, _product$value6$price2, _cart$value, _product$value7;
        var _product$value8, _product$value8$price, _product$value8$price2, _product$value9, _product$value0, currentUrl, AddedProperties;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return yieldToMain();
            case 2:
              trackDynamicYieldEvent({
                name: 'Add to Cart',
                properties: {
                  dyType: 'add-to-cart-v1',
                  value: formatDYprice(priceRegular.value, priceSpecial.value, false, numberItems.value),
                  currency: 'EUR',
                  productId: product === null || product === void 0 ? void 0 : (_product$value2 = product.value) === null || _product$value2 === void 0 ? void 0 : _product$value2.sku,
                  quantity: numberItems.value,
                  cart: [{
                    productId: product === null || product === void 0 ? void 0 : (_product$value3 = product.value) === null || _product$value3 === void 0 ? void 0 : _product$value3.sku,
                    quantity: numberItems.value,
                    itemPrice: formatDYprice(priceRegular.value, priceSpecial.value)
                  }]
                }
              });
              $trackers.gtm.trackAddToCart({
                title: productName.value,
                sku: (_product$value4 = product.value) === null || _product$value4 === void 0 ? void 0 : _product$value4.sku,
                priceRegular: priceRegular.value,
                priceSpecial: priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value,
                quantity: numberItems.value,
                isNewProduct: getIsNewProduct(product.value),
                isMaster: (_product$value5 = product.value) === null || _product$value5 === void 0 ? void 0 : _product$value5._master,
                itemLocation: 'product_page',
                currency: (_product$value6 = product.value) === null || _product$value6 === void 0 ? void 0 : (_product$value6$price = _product$value6.price) === null || _product$value6$price === void 0 ? void 0 : (_product$value6$price2 = _product$value6$price.value) === null || _product$value6$price2 === void 0 ? void 0 : _product$value6$price2.currencyCode,
                cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
                ctId: (_product$value7 = product.value) === null || _product$value7 === void 0 ? void 0 : _product$value7._id
              });
              if (!customerEmail.value) {
                _context3.next = 10;
                break;
              }
              currentUrl = computed(function () {
                return window.location.href;
              });
              AddedProperties = {
                AddedToCartValue: gtmValue(priceRegular.value, priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value, false, numberItems.value),
                AddedItemCategories: 'product',
                AddedItemCurrency: (_product$value8 = product.value) === null || _product$value8 === void 0 ? void 0 : (_product$value8$price = _product$value8.price) === null || _product$value8$price === void 0 ? void 0 : (_product$value8$price2 = _product$value8$price.value) === null || _product$value8$price2 === void 0 ? void 0 : _product$value8$price2.currencyCode,
                AddedItemImageURL: getProductMainImage.value || '',
                AddedItemPrice: priceRegular.value,
                AddedItemPriceDiscount: (priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value) || '',
                AddedItemProductID: ((_product$value9 = product.value) === null || _product$value9 === void 0 ? void 0 : _product$value9._id) || '',
                AddedItemProductName: productName.value,
                AddedItemProductSKU: product === null || product === void 0 ? void 0 : (_product$value0 = product.value) === null || _product$value0 === void 0 ? void 0 : _product$value0.sku,
                AddedItemProductUrl: productLink.value,
                AddedItemQuantity: numberItems.value,
                AddedItemURL: currentUrl.value
              };
              _context3.next = 9;
              return yieldToMain();
            case 9:
              klaviyoClientPushEvent(customerEmail.value, locale, AddedProperties, 'Added to cart');
            case 10:
              _context3.next = 12;
              return yieldToMain();
            case 12:
              $trackers.lux.addData('add-to-cart', 1);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _pushAddToCartAnalytics.apply(this, arguments);
    }
    function addToCart() {
      return _addToCart.apply(this, arguments);
    }
    function _addToCart() {
      _addToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              startWaiter('add-to-cart');
              toggleAddToCartModal();
              _context4.next = 5;
              return yieldToMain();
            case 5:
              _context4.next = 7;
              return addItemById({
                product: normalizeVariants([product.value])[0],
                quantity: parseInt("".concat(numberItems.value)),
                showConfirmation: !props.isMobileView
              });
            case 7:
              _context4.next = 13;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context4.t0);
            case 13:
              _context4.prev = 13;
              endWaiter('add-to-cart');
              return _context4.finish(13);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9, 13, 16]]);
      }));
      return _addToCart.apply(this, arguments);
    }
    function addToCartClick() {
      return _addToCartClick.apply(this, arguments);
    }
    function _addToCartClick() {
      _addToCartClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (isBookShop.value) {
                _context5.next = 6;
                break;
              }
              if (!props.isCustomizable.value) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", openModal());
            case 3:
              _context5.next = 5;
              return addToCart();
            case 5:
              pushAddToCartAnalytics();
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _addToCartClick.apply(this, arguments);
    }
    function getLabel(availableOptions, currentOption, attribute) {
      var _availableOptions$val, _availableOptions$val2, _availableOptions$val3;
      return ((_availableOptions$val = availableOptions.value) === null || _availableOptions$val === void 0 ? void 0 : (_availableOptions$val2 = _availableOptions$val[attribute]) === null || _availableOptions$val2 === void 0 ? void 0 : (_availableOptions$val3 = _availableOptions$val2.find(function (att) {
        var _currentOption$value;
        return (att === null || att === void 0 ? void 0 : att.value) === (currentOption === null || currentOption === void 0 ? void 0 : (_currentOption$value = currentOption.value) === null || _currentOption$value === void 0 ? void 0 : _currentOption$value[attribute]);
      })) === null || _availableOptions$val3 === void 0 ? void 0 : _availableOptions$val3.label) || '';
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      openModal: openModal,
      openCustomizer: openCustomizer,
      normalizeVariants: normalizeVariants,
      addItemById: addItemById,
      cartLoading: cartLoading,
      cart: cart,
      openBackInStockModal: openBackInStockModal,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      doActionOrLogin: doActionOrLogin,
      currency: currency,
      locale: locale,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      formatDYprice: formatDYprice,
      app: app,
      $sentry: $sentry,
      $trackers: $trackers,
      i18n: i18n,
      isAuthenticated: isAuthenticated,
      user: user,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      route: route,
      isBookShop: isBookShop,
      isButtonDisabled: isButtonDisabled,
      addToCartButtonText: addToCartButtonText,
      product: product,
      products: products,
      options: options,
      configuration: configuration,
      defaultProductImage: defaultProductImage,
      portionLabel: portionLabel,
      portionLabelSticky: portionLabelSticky,
      capacityLabel: capacityLabel,
      productName: productName,
      priceRegular: priceRegular,
      priceSpecial: priceSpecial,
      customerEmail: customerEmail,
      getProductMainImage: getProductMainImage,
      productLink: productLink,
      numberItems: numberItems,
      items: items,
      isAddToCartModalOpen: isAddToCartModalOpen,
      addToCartWorkshops: addToCartWorkshops,
      toggleAddToCartModal: toggleAddToCartModal,
      pushAddToCartAnalytics: pushAddToCartAnalytics,
      addToCart: addToCart,
      addToCartClick: addToCartClick,
      getLabel: getLabel,
      getProductPrice: getProductPrice,
      AzImg: AzImg,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AddToCart: AddToCart,
      ProductPagePrice: ProductPagePrice,
      PriceDiscountLabel: PriceDiscountLabel,
      AzLoader: AzLoader,
      PriceDisplay: PriceDisplay
    };
  }
});